module.exports = __webpack_public_path__ + "img/multihull--dark.dd4ffaf6.svg";